/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'https://dev.dashypay.com/core-api';
}

/**
 * Parameters for `WabaClientApi.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
